import axios from 'axios';
import Swal from 'sweetalert2';
import loadingGif from '@/assets/blue_loading.gif';
import $ from 'jquery';


export const dashboardMethodTiles = {

    tileRedirect(uuid) {

                Swal.fire({
                    title: 'Please wait...',
                    text: 'We are searching for your requested tile.',
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });

                axios({
                    method: "post",
                    url: this.baseAPIURL+"/apiv3/gettileredirectdata.json",
                    data: { uuid },
                    headers: {
                        "auth": this.$store.getters.auth_token,
                    },
                })
                .then(async (response) => {
                    const tile = response.data?.data?.[0];

                    if (!tile) { //GUARD
                        if (this.$route.query.entrytile) {
                            setTimeout(() => {
                            this.$router.replace({ name: 'dashboard', query: {} }).catch(() => {});
                            }, 0);
                        }

                        Swal.fire({
                            title: `Tile Not Found!`,
                            text: `The requested tile does not exist or is no longer accessible.`,
                            icon: 'warning',          
                            allowOutsideClick: false, 
                            customClass: {
                                confirmButton: 'px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-900 mx-2 my-2 border border-blue-600'
                            },
                            confirmButtonText: 'OK',  
                        });

                        return;
                    }
                    
                    const bookCode  = tile.book_code;
                    const tileId    = tile.tile_id;
                    const pageTitle = tile.page_title;

                    if (!this.active_books.includes(bookCode)) { // if false

                        if (this.$route.query.entrytile) {
                            setTimeout(() => {
                            this.$router.replace({ name: 'dashboard', query: {} }).catch(() => {});
                            }, 0);
                        }

                        Swal.fire({
                            title: `Tile Access Unavailable`,
                            text: `Access to this feature isn’t enabled. Check Settings or contact your administrator.`,
                            icon: 'warning',          
                            allowOutsideClick: false, 
                            customClass: {
                                confirmButton: 'px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-900 mx-2 my-2 border border-blue-600'
                            },
                            confirmButtonText: 'OK',  
                        });

                        return;
                    } else { // if true
                        this.$store.dispatch('setLoading', false);

                        this.selectBook(bookCode);
                        await this.sleep(1000); // short delay to ensure DOM updates

                        try {
                            await this.waitForElement(`#page-${pageTitle}`);
                        } catch {
                            await this.sleep(500); // fallback wait if element still missing
                        }

                        this.toggleSubItems(0, pageTitle);

                        this.tile_selected(bookCode, tileId);
                        await this.sleep(1000);

                        this.selectPage(pageTitle);
                        await this.sleep(1000);


                        if (this.$route.query.entrytile) {
                            setTimeout(() => {
                            this.$router.replace({ name: 'dashboard', query: {} }).catch(() => {});
                            setTimeout(() => Swal.close(), 1000);
                            }, 0);
                        }
                    }
                });
                
    },

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },

    checkCountTile(){
        if (this.showTile[0].length == 0) {
            this.isThereTile = false;
        } else {
            this.isThereTile = true;
        }
    },

    reload_tile() {
        this.tile_selected(this.$store.getters.selected_book, this.$store.getters.active_tile.id);
    },

    async tile_selected (book, tile_id) {
        this.obj.html = '';
        this.str_concat = '';
        this.other_options = [];
        this.tile_option_index = 0;

        this.trackFrequentlyUsedTile(book, tile_id);

        this.findTileParent(tile_id);

        if (this.$store.getters.vuexLoaderTrigger == false) {
            if (this.$store.getters.tile_view_display == 'Progressive') {
                
                this.progressive_tile_selected(book, tile_id);
            } else {
                this.default_tile_selected(book, tile_id);
            }
        }
    
    },

    findTileParent(tile_id) {
        const tileId = tile_id;

        const pageIndex = this.active_pages.findIndex((page) =>
            page.tiles.some((tile) => tile.id === tileId)
        );

        this.openSections = pageIndex;
    },

    progressive_tile_selected(book, tile_id) {
        if (this.axiosCallInProgress == false) {
            this.showPopup = false;
            this.axiosCallInProgress = true;
            var bodyFormData = new FormData();
            bodyFormData.append("code", book);
            bodyFormData.append("tile_id", tile_id);
            this.nextbtn = "Next";
            this.tile_loaded = false;
            this.load_current_icon = false;
            this.bp_integration = [];
            this.if_condition = {};
            this.url_get_options = [];
            this.submittable = false;
            this.selectedValue = [];
            this.totalpages = 0;
            this.file_uploads = [];
        
                axios({
                    method: "post",
                    url: this.baseAPIURL+"/apiv3/gettile.json",
                    data: bodyFormData,
                    headers: {
                        "auth": this.$store.getters.auth_token,
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {

                    if ( response.data.tile[0].tile_options.some(ele => ele.syntax === 'barcode') ||
                        response.data.tile[0].tile_options.some(ele => ele.syntax === 'camera') ||
                        response.data.tile[0].tile_options.some(ele => ele.syntax === 'audio') ) {

                            Swal.fire({
                                title: 'Oops!',
                                icon: 'warning',
                                html: '<p style="text-align: left;">Hey there!</p><br>'+
                                '<p style="text-align: left;">This tile uses one of the following devices that are currently unsupported by Tap Web:</p><br>'+
                                '<ul style="text-align: left;">'+
                                '<li>&#8226; Camera</li>'+
                                '<li>&#8226; Audio</li>'+
                                '<li>&#8226; Barcode</li>'+
                                '</ul>'+
                                '<br><p style="text-align: left;">We are continuing to develop Tap Web and will have this available soon. Meanwhile, you can use Tap Mobile to access this option.</p>'+
                                '<br><p style="text-align: left;">Thank you!</p>',
                                allowOutsideClick: true,
                                allowEscapeKey: true,
                            })
                            
                    } else {
                        this.$store.dispatch('activeTile', {
                            tilecontent: response.data.tile[0],
                            tile_id: response.data.tile[0].id,
                        });

                        this.obj.html = `<img src="${loadingGif}" alt="Loading content..." width="50" height="50" />`;
                    
                        if (this.$store.getters.active_tile.email_to_cloudstaffer === "yes" || 
                        this.$store.getters.active_tile.send_to_default_email === "yes" || 
                        this.$store.getters.active_tile.send_to_default_mobile === "yes" ||
                        this.$store.getters.active_tile.send_to_webhook === "yes" ||
                        this.$store.getters.active_tile.has_google_sheet === "yes" ||
                        this.$store.getters.active_tile.has_excel === "yes"
                        ) {
                            this.submittable = true;
                        }

                        this.$store.getters.active_tile.tile_options.map((tiles) => {

                            if (tiles.syntax !== 'rocketchat' && tiles.syntax !== 'urlget') {
                                this.totalpages += 1;
                            }
                        });


                        if (this.totalpages == 0) {
                            this.nextbtn = "Close";
                        } else if (this.totalpages == 1) {
                            if (this.submittable == false) {
                                this.nextbtn = "Close";
                            } else {
                                this.nextbtn = this.$store.getters.active_tile.submit_label;
                            }
                        }
        
                        
                        Object.keys(this.dynamic_mergecodes).map((mergecodes, index) => {
                            if (index > (4+this.book_mergecodes_length)) { //4 here is based on the number of keys set to dynamic mergecodes when selecting a book
                                delete this.dynamic_mergecodes[mergecodes];
                            }
                        });

                        this.currentPage = 1;
                        this.prepareObj();

                        setTimeout(() => {
                            this.obj.html = this.getCurrentTile(0);
                            this.tile_loaded = true;
                        }, 300);


                        setTimeout(() => {
                            this.$store.getters.active_tile.tile_options.map((tiles, index) => {
                                if (tiles.syntax != 'rocketchat' && tiles.syntax != 'urlget') {
                                    if (tiles.is_condition == true) {
                                        document.getElementById(`bullet${index+1}`).style.display = "none";
                                    }
                                } 
                            });
                        }, 400);


                        setTimeout(() => {
                            this.load_current_icon = true;
                        }, 80);


                        this.selectPage(response.data.tile[0].page_title);
                        this.search_tile = '';
                        this.current_icon = response.data.tile[0].icon;
                        

                        setTimeout(() => {
                            this.load_current_icon = false;
                        }, 10);
                    }
                }).catch(error => {
                    if (error.response) {
                        if (error.response.data.code === 401) {
                            Swal.fire({
                                title: 'Oops!',
                                icon: 'warning',
                                html: '<p style="text-align: center;">This session has expired. Please try to login again.</p>',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                confirmButtonText: 'Go to login page',
                                confirmButtonColor: "#145DA0"
                            }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                    this.$store.dispatch('logoutUser');
                                    this.$router.push('/');
                                    this.$moshaToast("You have logged-out!", { type: "success" });
                                }
                            });
                        } else {
                            this.handle_error();  
                        }
                    } else {
                        this.handle_error(); // Call your error handling function for CORS errors
                    }
                }).finally(() => {
                    this.axiosCallInProgress = false;
                });
        }
    
        
    },

    default_tile_selected(book, tile_id) {
    
        var bodyFormData = new FormData();
        bodyFormData.append("code", book);
        bodyFormData.append("tile_id", tile_id);
        this.tile_loaded = false;
        this.load_current_icon = false;
        this.bp_integration = [];
        this.if_condition = {};
        this.url_get_options = [];
        this.file_uploads = [];
        this.submittable = false;
        this.showPopup = false;

        axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/gettile.json",
            data: bodyFormData,
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "multipart/form-data",
            },
        })
        .then(response => {

            if ( response.data.tile[0].tile_options.some(ele => ele.syntax === 'barcode') ||
                response.data.tile[0].tile_options.some(ele => ele.syntax === 'camera') ||
                response.data.tile[0].tile_options.some(ele => ele.syntax === 'audio') ) {

                    Swal.fire({
                        title: 'Oops!',
                        icon: 'warning',
                        html: '<p style="text-align: left;">Hey there!</p><br>'+
                        '<p style="text-align: left;">This tile uses one of the following devices that are currently unsupported by Tap Web:</p><br>'+
                        '<ul style="text-align: left;">'+
                        '<li>&#8226; Camera</li>'+
                        '<li>&#8226; Audio</li>'+
                        '<li>&#8226; Barcode</li>'+
                        '</ul>'+
                        '<br><p style="text-align: left;">We are continuing to develop Tap Web and will have this available soon. Meanwhile, you can use Tap Mobile to access this option.</p>'+
                        '<br><p style="text-align: left;">Thank you!</p>',
                        allowOutsideClick: true,
                        allowEscapeKey: true,
                    })
            } else {
                this.$store.dispatch('activeTile', {
                    tilecontent: response.data.tile[0],
                    tile_id: response.data.tile[0].id,
                });
                

                //check if tile is submittable or not
                if (this.$store.getters.active_tile.email_to_cloudstaffer === "yes" || 
                    this.$store.getters.active_tile.send_to_default_email === "yes" || 
                    this.$store.getters.active_tile.send_to_default_mobile === "yes" ||
                    this.$store.getters.active_tile.send_to_webhook === "yes" ||
                    this.$store.getters.active_tile.has_google_sheet === "yes" ||
                    this.$store.getters.active_tile.has_excel === "yes"
                ) {
                    this.submittable = true;
                }

                response.data.tile[0].tile_options.map((item) =>{
                    if ( item.syntax === "rocketchat" || item.syntax === "urlget" ) {
                        this.submittable = true;
                    }
                });

            this.$gtag.event('selectTile', {
                'tile_visited': this.$store.getters.selected_book+'/'+this.$store.getters.selected_page+'/'+response.data.tile[0].id+': '+response.data.tile[0].title
            });
            
            this.obj.html = '<img alt="" width="50" height="50" src="data:image/gif;base64,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" />';
                if (response.data.tile[0].tile_options.length == 1 && response.data.tile[0].tile_options[0].syntax == "location") {
                        var url = 'http://maps.google.com/?q=';
                        var searchlocation = response.data.tile[0].tile_options[0].json.description;
                        window.open(url+searchlocation,'_blank');
                }

                Object.keys(this.dynamic_mergecodes).map((mergecodes, index) => {
                    if (index > (3+this.book_mergecodes_length)) {
                        delete this.dynamic_mergecodes[mergecodes];
                    }
                });

            this.prepareObj();

                    setTimeout(() => {
                        this.obj.html = this.getHtml();
                        this.tile_loaded = true;
                    }, 300)

                    setTimeout(() => {
                        this.load_current_icon = true;
                    }, 80)
                    

                this.selectPage(response.data.tile[0].page_title);
                this.search_tile = '';
                this.current_icon = response.data.tile[0].icon;

                setTimeout(() => {
                    this.load_current_icon = false;
                }, 10);
            }

        
        }).catch((error) => {
            if (error.response) {
                if (error.response.data.code === 401) {
                    Swal.fire({
                        title: 'Oops!',
                        icon: 'warning',
                        html: '<p style="text-align: center;">This session has expired. Please try to login again.</p>',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: 'Go to login page',
                        confirmButtonColor: "#145DA0"
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                            this.$store.dispatch('logoutUser');
                            this.$router.push('/');
                            this.$moshaToast("You have logged-out!", { type: "success" });
                        }
                    });
                } else {
                    this.handle_error();  
                }
            } else {
                this.handle_error(); // Call your error handling function for CORS errors
            }
        });
    },

    resetTile () {
        this.$store.dispatch('unsetActiveTile'); 
        var pagestr = this.$store.getters.selected_page.replace(/\s/g, '');
        setTimeout(() => {
            this.scrollPageFunc(pagestr);
        }, 10);

        this.tile_loaded = false;
        this.load_current_icon = false;
        // this.selectBook(this.$store.getters.selected_book);
    },

    
    next_page() {
        if (this.totalpages == 0) {
            this.resetTile();
            return;
        }

        if (this.currentPage <= this.totalpages) {
            this.user_action = 'forward';

            var skip = false;
            if (this.pageloading == false) {
                // this part will change the text of "NEXT" button

                // THIS PART WILL GET THE ENTRY OR INPUT FROM THE USER
                if (this.typeOfInput == 'inputbox') {
                    const selectElement = document.getElementsByName(this.currentStep)[0];

                    if (selectElement) {
                        const selectValue = selectElement.value;

                        /* eslint-disable */
                        var sanitized_event_value = "";
                        sanitized_event_value = selectValue.replace(/\</g,"&lt;");   //for <
                        sanitized_event_value = sanitized_event_value.replace(/\>/g,"&gt;");  //for >

                        this.dynamic_mergecodes[this.currentStep] = sanitized_event_value;
                    }
                } else if (this.typeOfInput == 'button' || this.typeOfInput == 'radio') {
                    const selectedRadioButton = document.querySelector('input[name="'+this.currentStep+'"]:checked');

                    // Check if a radio button is selected
                    if (selectedRadioButton) {
                        // Get the value of the selected radio button
                        const selectValue = selectedRadioButton.value;
                        if (this.dynamic_mergecodes[this.currentStep]) {
                            this.dynamic_mergecodes[this.currentStep] = [];
                            this.dynamic_mergecodes[this.currentStep].push(selectValue);
                        }

                    } else {
                        console.log("No radio button selected");
                    }
                } else if (this.typeOfInput == 'file') {
                    var fileInput = document.querySelector(`input[type="file"][name="${this.currentStep}"]`);

                    this.dynamic_mergecodes[this.currentStep] = fileInput.files[0].name;
                } else {
                    const checkboxes = document.getElementsByName(this.currentStep);
                    this.dynamic_mergecodes[this.currentStep] = [];
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].checked) {
                            this.dynamic_mergecodes[this.currentStep].push(checkboxes[i].value);
                        }
                    }
                }

                // THIS BLOCK WILL RUN THE INPUT IN THE VALIDATION FUNCTION IF WITH VALIDATION
                if (this.validation[this.currentStep]) {
                    var valid_value = this.validation[this.currentStep].validation_value;

                    //THIS BLOCK WILL DETERMINE IF VALIDATION HAS MERGECODES
                    valid_value = this.run_mergecode_search(valid_value);
                    //THIS BLOCK WILL DETERMINE IF VALIDATION HAS MERGECODES

                    if (this.validation[this.currentStep].condition == "badgepack") {
                        if (this.bp_integration.length > 0) {
                            //this block checks if task is all done
                            let allChecked = true;
                            // Iterate over the bp_integration array
                            for (const item of this.bp_integration) {
                                if (item.is_checked !== "yes") {
                                    allChecked = false;
                                    break; // No need to continue checking, as one item is not checked
                                }
                            }

                            // Check the value of allChecked
                            if (allChecked) {
                                this.validation[this.currentStep].condition_met = true;
                            } else {
                                this.validation[this.currentStep].condition_met = false;
                            }
                        }

                    } else {
                        if (this.if_function(
                            this.currentStep,
                            valid_value,
                            this.validation[this.currentStep].condition)
                        ) {
                            this.validation[this.currentStep].condition_met = true;
                        } else {
                            this.validation[this.currentStep].condition_met = false;
                        }
                    }
                }

                //CHECK INCOMING PAGE
                var delaytime = 0;

                if (this.$store.getters.active_tile.tile_options[this.tile_option_index+1]) {

                    if (this.$store.getters.active_tile.tile_options[this.tile_option_index+1].syntax === "msgbox") {

                        if (this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.message_type === "URL") {
                            if (!this.validation[this.currentStep] || this.validation[this.currentStep].condition_met == true) {

                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { [this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.tag_name]: 'init'});

                                var url = this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.url;
                                var reg = new RegExp(/\{\{(.*?)\}\}/g);
                                var matches = this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.url.match(reg);
                                var found;
                                url;

                                if (matches) {
                                    found = reg.exec(this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.url);

                                    if (this.dynamic_mergecodes[found[1]]) {
                                        url = this.dynamic_mergecodes[found[1]][0];
                                        this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.tag_name] = url;
                                    }
                                } else {
                                    this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.tag_name] = url;
                                }

                                if (this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.tag_name].includes('uberlist')) {

                                    var settings = {
                                        "url": this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.tag_name],
                                        "mode": 'cors',
                                        "method": "GET",
                                        "timeout": 0,
                                    };

                                    this.message_url = {};
                                    axios(settings)
                                        .then((response) => {
                                            if (response.data[0].ListMemo == null) {
                                                this.message_url[this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.tag_name] = response.data;
                                            } else {
                                                this.message_url[this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.tag_name] = response.data[0].ListMemo;
                                            }
                                        })
                                        .catch((error) => {
                                            return error;
                                        });
                                } else {
                                    this.message_url[this.$store.getters.active_tile.tile_options[this.tile_option_index+1].json.tag_name] = this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[this.tile_option_index].json.tag_name];
                                }

                                delaytime = 2500;
                            } else {
                                this.$moshaToast(this.validation[this.currentStep].message, { type: "danger" });
                                skip = true;
                            }
                        }
                    } else if (this.$store.getters.active_tile.tile_options[this.tile_option_index+1].syntax === "rocketchat") {

                        if (!this.validation[this.currentStep] || this.validation[this.currentStep].condition_met == true) {

                            var myDiv = document.getElementById("tile_content_div");
                            myDiv.scrollTop = 0;
                            this.tile_option_index = this.tile_option_index + 2;

                            //check the next occurrence of tile syntax that does not contain rocketchat or urlget

                            var skiptoindex = 0

                            for (var x = this.tile_option_index; x<this.$store.getters.active_tile.tile_options.length; x++) {
                                if (this.$store.getters.active_tile.tile_options[x].syntax !== "rocketchat" && this.$store.getters.active_tile.tile_options[x].syntax !== "urlget") {
                                    skiptoindex = x;
                                    break;
                                } else { // execute the rocketchat
                                    if (this.$store.getters.active_tile.tile_options[x].syntax === "urlget") {
                                        this.urlget_rocketchat_helper(x);
                                    }

                                    if (this.$store.getters.active_tile.tile_options[x].syntax === "rocketchat") {
                                        this.urlget_rocketchat_helper(x);
                                    }
                                }
                            }

                            this.urlget_rocketchat_helper(this.tile_option_index-1);

                            if (this.currentPage == this.totalpages) {  //PROCEEED TO SUBMISSION
                                if (this.submittable == true) {
                                    this.pre_progressive_submission();
                                } else {
                                    this.resetTile();
                                }
                                this.pageloading = false;
                            } else {
                                if (this.currentPage == this.totalpages-1) {
                                    if (this.submittable == false) {
                                        this.nextbtn = "Close";
                                    } else {
                                        this.nextbtn = this.$store.getters.active_tile.submit_label;
                                    }
                                }

                                this.tile_option_index = skiptoindex;
                                this.currentPage = this.currentPage + 1;
                                this.if_condition_helper(this.tile_option_index);
                                this.pageloading = false;
                            }
                            skip = true;
                        } else {
                            this.$moshaToast(this.validation[this.currentStep].message, { type: "danger" });
                            skip = true;
                        }

                    } else if (this.$store.getters.active_tile.tile_options[this.tile_option_index+1].syntax === "urlget") {
                        if (!this.validation[this.currentStep] || this.validation[this.currentStep].condition_met == true) {

                            myDiv = document.getElementById("tile_content_div");
                            myDiv.scrollTop = 0;
                            this.tile_option_index = this.tile_option_index + 2;

                            //check the next occurrence of tile syntax that does not contain rocketchat or urlget

                            skiptoindex = 0

                            for (x = this.tile_option_index; x<this.$store.getters.active_tile.tile_options.length; x++) {
                                if (this.$store.getters.active_tile.tile_options[x].syntax !== "rocketchat" && this.$store.getters.active_tile.tile_options[x].syntax !== "urlget") {
                                    skiptoindex = x;
                                    break;
                                } else {
                                    if (this.$store.getters.active_tile.tile_options[x].syntax === "urlget") {
                                        this.urlget_rocketchat_helper(x);
                                    }

                                    if (this.$store.getters.active_tile.tile_options[x].syntax === "rocketchat") {
                                        this.urlget_rocketchat_helper(x);
                                    }
                                }
                            }

                            this.urlget_rocketchat_helper(this.tile_option_index-1);

                            if (this.currentPage == this.totalpages) {  //PROCEEED TO SUBMISSION
                                if (this.submittable == true) {
                                    this.pre_progressive_submission();
                                } else {
                                    this.resetTile();
                                }
                                this.pageloading = false;
                            } else {
                                if (this.currentPage == this.totalpages-1) {
                                    if (this.submittable == false) {
                                        this.nextbtn = "Close";
                                    } else {
                                        this.nextbtn = this.$store.getters.active_tile.submit_label;
                                    }
                                }

                                this.tile_option_index = skiptoindex;
                                this.currentPage = this.currentPage + 1;
                                this.if_condition_helper(this.tile_option_index);
                                this.pageloading = false;
                            }
                            skip = true;
                        } else {
                            this.$moshaToast(this.validation[this.currentStep].message, { type: "danger" });
                            skip = true;
                        }

                    }
                }

                // CHECK VALIDATION IF CONDITIONS ARE MET
                if (skip == false) {
                    if (!this.validation[this.currentStep] || this.validation[this.currentStep].condition_met == true) {
                        this.pageloading = true;
                        if (this.currentPage == this.totalpages) {  //PROCEEED TO SUBMISSION
                            if (this.submittable == true) {
                                this.pre_progressive_submission();
                            } else {
                                this.resetTile();
                            }
                            this.pageloading = false;
                        } else {  //PROCEEED TO NEXT PAGE
                            // IF THE NEXT IS LAST PAGE THIS WILL CHANGE THE TEXT OF SUBMIT BUTTON
                            if (delaytime != 0) {
                                this.nextbtn = "Loading...";
                            }

                            setTimeout(() => {
                                if (this.currentPage == this.totalpages-1) {
                                    if (this.submittable == false) {
                                        this.nextbtn = "Close";
                                    } else {
                                        this.nextbtn = this.$store.getters.active_tile.submit_label;
                                    }
                                } else {
                                    this.nextbtn = "Next";
                                }

                                this.tile_option_index = this.tile_option_index + 1;
                                this.currentPage = this.currentPage + 1;

                                var myDiv = document.getElementById("tile_content_div");
                                myDiv.scrollTop = 0;

                                this.if_condition_helper(this.tile_option_index);
                                this.pageloading = false;
                            }, delaytime);

                        }
                    } else { // WHEN CONDITION DOES NOT MEET
                        this.$moshaToast(this.validation[this.currentStep].message, { type: "danger" });
                    }
                }
            }
        }
    },

    if_condition_helper(tile_option_index) {
                    var cont = false;
    
                    if (this.$store.getters.active_tile.tile_options[tile_option_index].is_condition == true) { //if theres a condition
                        if (this.if_function(this.$store.getters.active_tile.tile_options[tile_option_index].if_json.tile_option_tag_name,
                            this.$store.getters.active_tile.tile_options[tile_option_index].if_json.condition_value.replace("'", ''), 
                            this.$store.getters.active_tile.tile_options[tile_option_index].if_json.condition)) {
    
                            document.getElementById(`bullet${tile_option_index+1}`).style.display = "block";
                            cont = true;      //and the condition is met              
                        } else {
                            cont = false;      //and the condition is not met       
                        }
                    } else { //if theres no condition
                        cont = true; //so automatically it will be continued (true)
                    }
    
                    if (cont == true) { //if continue is true proceed to tile content
    
                        var element = document.getElementById(`bullet${tile_option_index}`);
    
                        if (element) {
                            document.getElementById(`bullet${tile_option_index}`).style.display = "block";
                        }
    
                        this.obj.html = this.getCurrentTile(tile_option_index);
                    } else { //go 1 step forward to check again
                        this.pageloading = false;
                    
                        if (this.user_action == 'forward') {
                            document.getElementById(`bullet${tile_option_index}`).style.display = "none";
                            this.next_page();
                        } else {
                            this.prev_page();
                        }
                    }
    },
    
    prev_page() {
                    if (this.currentPage != 1) {
                        this.user_action = 'backward';
    
                        
                        if (this.$store.getters.active_tile.tile_options[this.tile_option_index-1].syntax === "rocketchat") {
                            //check the next occurrence of tile syntax that does not contain rocketchat or urlget
                            this.tile_option_index = this.tile_option_index - 2;
                            var skiptoindex = 0
                    
                            for (var x = this.tile_option_index; x>0; x--) {
                                if (this.$store.getters.active_tile.tile_options[x].syntax !== "rocketchat" && this.$store.getters.active_tile.tile_options[x].syntax !== "urlget") {
                                    skiptoindex = x;
                                    break;
                                } 
                            }
                        
                            this.tile_option_index = skiptoindex;
                        
    
                        } else if (this.$store.getters.active_tile.tile_options[this.tile_option_index-1].syntax === "urlget") {
                            //check the next occurrence of tile syntax that does not contain rocketchat or urlget
                            this.tile_option_index = this.tile_option_index - 2;
                            skiptoindex = 0
    
                            for (x = this.tile_option_index; x>0; x--) {
                                if (this.$store.getters.active_tile.tile_options[x].syntax !== "rocketchat" && this.$store.getters.active_tile.tile_options[x].syntax !== "urlget") {
                                    skiptoindex = x;
                                    break;
                                } 
                            }
                        
    
                            this.tile_option_index = skiptoindex;
                        
                        } else {
                            this.tile_option_index = this.tile_option_index - 1;
                        }
    
                        if (this.$store.getters.active_tile.tile_options[this.tile_option_index+1].is_condition == true) {
                            delete this.dynamic_mergecodes[this.currentStep];
                        }
    
                        this.currentPage = this.currentPage - 1;
    
                        this.nextbtn = "Next";
                        var myDiv = document.getElementById("tile_content_div");
                        myDiv.scrollTop = 0;
                        this.if_condition_helper(this.tile_option_index);
                    }
    },
    
    pre_progressive_submission() {
                    if (this.$store.getters.active_tile.safety_send == "yes") {
                        Swal.fire({
                            title: this.$store.getters.active_tile.safety_send_message,
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            denyButtonText: `Don't save`,
                            confirmButtonColor: "#145DA0"
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                            Swal.fire('Saved!', '', 'success')
                            
                            this.post_progressive_submission();
                            } else {
                            Swal.fire({title: 'Sending cancelled', icon: 'info', confirmButtonText: 'Okay'})
                            }
                        })
                    } else {  /////////////////// NO SAFETY SEND
                        this.post_progressive_submission();
                    }
    },
    
    post_progressive_submission() {
    
                    var today = new Date();
                    
                    Swal.fire({
                        title: 'Please wait...',
                        html: '<small>Loading...</small>',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            Swal.showLoading()
                        },
                    })
    
                    this.main_data["data"] = [];
                        this.$store.getters.active_tile.tile_options.map((tiles) => {
                            this.main_data["tile_id"] =  this.$store.getters.active_tile.id;
    
                            var value = this.dynamic_mergecodes[tiles.json.tag_name];
    
                            this.main_data["data"].push({
                                "sort": tiles.sort,
                                "tag": tiles.json.tag,
                                "type": tiles.syntax,
                                "value": value
                            });
                    });
    
                    var formSubmit = {
                        "submit_data": JSON.stringify(this.main_data),
                        "token_id": this.$store.getters.auth_token,
                        "location": this.ip_location,
                        "user_name": this.$store.getters.auth_username,
                        "user_domain": window.location.origin,
                        "user_guid": this.$store.getters.auth_guid,
                        "user_book": this.$store.getters.selected_book,
                        "user_page": this.$store.getters.selected_page,
                        "user_tile": this.$store.getters.active_tile.title,
                        "user_store": this.user_store,
                        "user_brand": "Web",
                        "date_now": today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate(),
                        "time_now": this.getClockTime(),
                        "tap_version": this.appVersion,
                        "user_public_ip": this.ip_public,
                        "user_local_ip": "--",
                        "user_data_type": "WIFI",
                        "user_wifi_ssid": "HUAWEI-2.4G-g5sA",
                        "user_model": "Web",
                        "user_email_base64": "",
                        "user_version": this.appVersion,
                    }
    
                    if (this.file_uploads.length > 0) {
                        var formData = new FormData();
    
                        // Append properties from formSubmit2 to the FormData object
                        for (const key in formSubmit) {
                        if (formSubmit.hasOwnProperty(key)) {
                            formData.append(key, formSubmit[key]);
                        }
                        }
    
                        // Add file data from file_uploads
                        this.file_uploads.forEach(upload => {
                            if (upload.value) {
                            formData.append(`data_${upload.sort}`, upload.value);
                            }
                        });
                    } else {
                        formData = formSubmit;
                    }
    
                    var settings = {
                        "url": this.baseAPIURL+"/apiv3/submit.json",
                        "method": "POST",
                        "timeout": 0,
                        "headers": {
                            "auth": this.$store.getters.auth_token,
                        },
                        "processData": false,
                        "mimeType": "multipart/form-data",
                        "contentType": false,
                        "data": formData
                    };
    
                    axios(settings)
                        .then((response) => {
                        
                            this.$store.dispatch('unsetTilesCompleteClear', this.$store.getters.active_tile.id);
    
                            Swal.close();
                            Swal.fire({
                                title: 'Done!',
                                confirmButtonText: 'Okay',
                                confirmButtonColor: '#2563EB'
                            });
                            this.resetTile();
    
                        return response;
                    })
                    .catch((error) => {
                        console.log(error);
                        if (error.response && error.response.status === 423) {
                            Swal.close();
                            Swal.fire({
                                title: 'Too Many Requests',
                                text: 'You have submitted too many requests. Please wait a moment and try again.',
                                icon: 'warning',
                                confirmButtonText: 'Okay',
                                customClass: {
                                    confirmButton: 'px-6 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-blue-600'
                                }
                            });
                        }
                        return error;
                    });
        
                    
    },
    
    selectbox_button(tileOptionsIndex) {
                    this.typeOfInput = 'button';
    
                    var str;
                    var sanitized_title = "";
                    var sanitized_details = "";
                    /* eslint-disable */
                    sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;");   //for <
                    sanitized_title = sanitized_title.replace(/\>/g,"&gt;");  //for >
                    
                    /* eslint-disable */
                    sanitized_details = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.description.replace(/\</g,"&lt;");   //for <
                    sanitized_details = sanitized_details.replace(/\>/g,"&gt;");   //for >
    
                    /* eslint-disable */
                    if (!this.dynamic_mergecodes.hasOwnProperty(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name)) {
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, {[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]: []});
                    } else {
                        this.selectedValue = this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name][0];
                    }     
    
                    if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'url') {   ///OPTION TYPE
                            str = "";
                            var content_value = [];
    
                            if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.includes('badgepack')) {
    
                                this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                    "validation_value":'',
                                    "condition":'badgepack',
                                    "message":'Complete the task.',
                                    "condition_met":false
                                }
    
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
        
                                    var hasValue = options;
                                    content_value.push(hasValue);
        
                                    index = this.bp_integration.map(badge => {
                                        return badge.title; 
                                    }).indexOf(options);
                                
                                    var sanitized_options = "";
                                    var sanitized_value = "";
                                    /* eslint-disable */
                                    sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                    sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                    sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                    sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                                
                                    if (this.bp_integration[index]) {
                                        if (this.bp_integration[index].is_checked == 'yes') {
                                            str = str + "<div class='ml-2'><input type='radio' id='"+
                                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                            +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                            "<label for='"+
                                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                            +index+"' style='background-color: green; color: white; border: 1px solid white;'>"+sanitized_options+"</label></div>";
                                        } else {
                                            str = str + "<div class='ml-2'><input type='radio' id='"+
                                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                            +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                            "<label for='"+
                                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                            +index+"'>"+sanitized_options+"</label></div>";
                                        }
                                    } else {
                                        str = str + "<div class='ml-2'><input type='radio' id='"+
                                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                            +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                            "<label for='"+
                                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                            +index+"'>"+sanitized_options+"</label></div>";
                                    }
            
                                    });   
                            } else {
                                this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                    "validation_value":'',
                                    "condition":'notnull',
                                    "message":'This field is required.',
                                    "condition_met":false
                                }
    
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
        
                                if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url_return == 'name') {
                                    var hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label[index];
                                } else {
                                    hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_value[index];
                                }
    
                                
                                content_value.push(hasValue);
                            
                                var sanitized_options = "";
                                var sanitized_value = "";
                                /* eslint-disable */
                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                            
                                if (sanitized_value === this.selectedValue) { //if this is true then this radio will be checked
                                    str = str + "<div class='ml-2'><input type='radio' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' name='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +"' value='"+sanitized_value+"' style='visibility:hidden;' checked>"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                } else {
                                    str = str + "<div class='ml-2'><input type='radio' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' name='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +"' value='"+sanitized_value+"' style='visibility:hidden;' >"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                }
        
                                });   
                            }
                    } else {
                        if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.length > 0) {
                            str = '';
                            var content_value = [];
    
                            this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                "validation_value":'',
                                "condition":'notnull',
                                "message":'This field is required.',
                                "condition_met":false
                            }
    
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
                                if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'name_value') {
                                    var hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_value[index];
                                } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'name-only') {
                                    hasValue = options;
                                } else {
                                    hasValue = options;
                                }
    
                                hasValue = hasValue.replaceAll("'", "");
                                content_value.push(hasValue)
    
                                var sanitized_options = "";
                                var sanitized_value = "";
                                /* eslint-disable */
                                sanitized_options = options.replace(/\</g,"&lt;");   //for <
                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;");   //for >
                                sanitized_value = hasValue.replace(/\</g,"&lt;");   //for <
                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;");
    
                                if (sanitized_value === this.selectedValue) { //if this is true then this radio will be checked
                                    str = str + "<div class='ml-2'><input type='radio' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' name='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +"' value='"+sanitized_value+"' style='visibility:hidden;' checked>"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                } else {
                                    str = str + "<div class='ml-2'><input type='radio' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' name='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +"' value='"+sanitized_value+"' style='visibility:hidden;' >"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                }
                            });
    
    
    
                        } else {
                            str = "<small><i>No data found.</i></small>";
                        }
                        
                    } ///OPTION TYPE CLOSE
    
                    
                
                    if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.allow_other_option === "yes") {
                        if(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'url') {
                            if (!this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.includes('badgepack')) {
                                str = this.allow_other_option_helper(content_value, str, tileOptionsIndex, "button");
                            } 
                        } else {
                            str = this.allow_other_option_helper(content_value, str, tileOptionsIndex, "button");
                        }
                    }
    
                    var prefix_str = "<br><span class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                    sanitized_title+"</span>"+sanitized_details+"<br><br>";
    
                    str = prefix_str + "<div class='radio-toolbar'><div class='parent'>"+str+"</div></div>";
    
    
                    return str;
    },

    selectbox_radio(tileOptionsIndex) {
                    this.typeOfInput = 'radio';
    
                    var str;
                    var sanitized_title = "";
                    var sanitized_details = "";
                    /* eslint-disable */
                    sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;");   //for <
                    sanitized_title = sanitized_title.replace(/\>/g,"&gt;");  //for >
                    /* eslint-disable */
                    sanitized_details = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.description.replace(/\</g,"&lt;");   //for <
                    sanitized_details = sanitized_details.replace(/\>/g,"&gt;");   //for >
    
                    /* eslint-disable */
                    if (!this.dynamic_mergecodes.hasOwnProperty(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name)) {
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, {[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]: []});
                    } else {
                        this.selectedValue = this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name][0];
                    }
                    
                    if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'url') {   ///URL
                        str = "";
                        var content_value = [];
    
                        if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.includes('badgepack')) {
                            
                            this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                "validation_value":'',
                                "condition":'badgepack',
                                "message":'Complete the task.',
                                "condition_met":false
                            }
                            
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
    
                                var hasValue = options;
    
                                index = this.bp_integration.map(badge => {
                                    return badge.title; 
                                }).indexOf(options);
                            
                                var sanitized_options = "";
                                var sanitized_value = "";
                                /* eslint-disable */
                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                            
                                if (this.bp_integration[index]) {
                                    if (this.bp_integration[index].is_checked == 'yes') {
                                        str = str + "<div class='ml-2'><input type='radio' id='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                        +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                        "<label for='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                        +index+"' style='background-color: green; color: white; border: 1px solid white;'>"+sanitized_options+"</label></div>";
                                    } else {
                                        str = str + "<div class='ml-2'><input type='radio' id='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                        +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                        "<label for='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                        +index+"'>"+sanitized_options+"</label></div>";
                                    }
                                } else {
                                    str = str + "<div class='ml-2'><input type='radio' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                }
        
                                });   
                        } else {
                            this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                "validation_value":'',
                                "condition":'notnull',
                                "message":'This field is required.',
                                "condition_met":false
                            }
    
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
    
                            if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url_return == 'name') {
                                var hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label[index];
                            } else {
                                hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_value[index];
                            }
                            
                            content_value.push(hasValue);
                        
                            var sanitized_options = "";
                            var sanitized_value = "";
                            /* eslint-disable */
                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                        
                            if (sanitized_value === this.selectedValue) { //if this is true then this radio will be checked
                                str = str + "<div class='ml-2'><input type='radio' id='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +index+"' name='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +"' value='"+sanitized_value+"' checked>"+
                                "<label for='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +index+"'>"+sanitized_options+"</label></div>";
                            } else {
                                str = str + "<div class='ml-2'><input type='radio' id='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +index+"' name='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +"' value='"+sanitized_value+"' >"+
                                "<label for='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +index+"'>"+sanitized_options+"</label></div>";
                            }
    
                            });   
                        }
                    } else {
                        if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.length > 0) {
                            str = '';
                            var content_value = [];
    
                            this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                "validation_value":'',
                                "condition":'notnull',
                                "message":'This field is required.',
                                "condition_met":false
                            }
    
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
                                if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'name_value') {
                                    var hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_value[index];
                                } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'name-only') {
                                    hasValue = options;
                                } else {
                                    hasValue = options;
                                }
    
                                hasValue = hasValue.replaceAll("'", "");
                                content_value.push(hasValue);
    
                                var sanitized_options = "";
                                var sanitized_value = "";
                                /* eslint-disable */
                                sanitized_options = options.replace(/\</g,"&lt;");   //for <
                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;");   //for >
                                sanitized_value = hasValue.replace(/\</g,"&lt;");   //for <
                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;");
    
                                if (sanitized_value === this.selectedValue) { //if this is true then this radio will be checked
                                    str = str + "<div class='ml-2'><input type='radio' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' name='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +"' value='"+sanitized_value+"' checked>"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                } else {
                                    str = str + "<div class='ml-2'><input type='radio' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' name='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +"' value='"+sanitized_value+"' >"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                }
                            });
                            
                        } else {
                            str = "<small><i>No data found.</i></small>";
                        }
                    } ///OPTION TYPE CLOSE
                    //THIS BLOCK IS TO HANDLE THE "OTHER" option
                    if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.allow_other_option === "yes") {
                        if(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'url') {
                            if (!this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.includes('badgepack')) {
                                str = this.allow_other_option_helper(content_value, str, tileOptionsIndex, "radio");
                            } 
                        } else {
                            str = this.allow_other_option_helper(content_value, str, tileOptionsIndex, "radio");
                        }
                    }
    
                    var prefix_str = "<br><span class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                    sanitized_title+"</span>"+sanitized_details+"<br><br>";
    
                    var str_concat_prefix = "<div class='flex'><div class='flex flex-wrap overflow-hidden'>";
                    var str_concat_postfix = "</div></div>";
    
                    var finalstr = str_concat_prefix + str + str_concat_postfix;
    
                    str = prefix_str + "<div class='radio-toolbar'><div class='parent'>"+finalstr+"</div></div>";
    
                    return str;
    },
    
    selectbox_multiple(tileOptionsIndex) {
                    this.typeOfInput = 'checkbox';
    
                    var str;
                    
                    var sanitized_title = "";
                    var sanitized_details = "";
                    /* eslint-disable */
                    sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;");   //for <
                    sanitized_title = sanitized_title.replace(/\>/g,"&gt;");  //for >
                    /* eslint-disable */
                    sanitized_details = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.description.replace(/\</g,"&lt;");   //for <
                    sanitized_details = sanitized_details.replace(/\>/g,"&gt;");   //for >
    
    
                    /* eslint-disable */
                    if (!this.dynamic_mergecodes.hasOwnProperty(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name)) {
                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, {[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]: []});
                    } else {
                        this.selectedValue = this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name];
                    }
    
    
    
                    if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'url') {   ///URL
                        str = "";
                        var content_value = [];
                        if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.includes('badgepack')) {
                            
                            this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                "validation_value":'',
                                "condition":'badgepack',
                                "message":'Complete the task.',
                                "condition_met":false
                            }
                            
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
    
                                var hasValue = options;
    
                                index = this.bp_integration.map(badge => {
                                    return badge.title; 
                                }).indexOf(options);
                            
                                var sanitized_options = "";
                                var sanitized_value = "";
                                /* eslint-disable */
                                sanitized_options = options.replace(/\</g,"&lt;")   //for <
                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                                sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                            
                                if (this.bp_integration[index]) {
                                    if (this.bp_integration[index].is_checked == 'yes') {
                                        str = str + "<div class='ml-2'><input type='radio' id='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                        +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                        "<label for='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                        +index+"' style='background-color: green; color: white; border: 1px solid white;'>"+sanitized_options+"</label></div>";
                                    } else {
                                        str = str + "<div class='ml-2'><input type='radio' id='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                        +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                        "<label for='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                        +index+"'>"+sanitized_options+"</label></div>";
                                    }
                                } else {
                                    str = str + "<div class='ml-2'><input type='radio' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' data-inputtype='button_bp' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']+"' value='"+sanitized_value+"' style='visibility:hidden;'>"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                }
        
                                });   
                        } else {
                            this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                "validation_value":'',
                                "condition":'notnull',
                                "message":'This field is required.',
                                "condition_met":false
                            }
    
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
    
                            if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url_return == 'name') {
                                var hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label[index];
                            } else {
                                hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_value[index];
                            }
                            
                            content_value.push(hasValue);
                        
                            var sanitized_options = "";
                            var sanitized_value = "";
                            /* eslint-disable */
                            sanitized_options = options.replace(/\</g,"&lt;")   //for <
                            sanitized_options = sanitized_options.replace(/\>/g,"&gt;")   //for >
                            sanitized_value = hasValue.replace(/\</g,"&lt;")   //for <
                            sanitized_value = sanitized_value.replace(/\>/g,"&gt;")   //for >
                        
                            if (this.selectedValue.includes(sanitized_value)) { //if this is true then this radio will be checked
                                str = str + "<div class='ml-2'><input type='checkbox' id='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +index+"' name='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +"' value='"+sanitized_value+"' checked>"+
                                "<label for='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +index+"'>"+sanitized_options+"</label></div>";
                            } else {
                                str = str + "<div class='ml-2'><input type='checkbox' id='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +index+"' name='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +"' value='"+sanitized_value+"' >"+
                                "<label for='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +index+"'>"+sanitized_options+"</label></div>";
                            }
    
                            });  
                        }
                    } else {
                        if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.length > 0) {
                            str = '';
                            var content_value = [];
    
                            this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                "validation_value":'',
                                "condition":'notnull',
                                "message":'This field is required.',
                                "condition_met":false
                            }
    
    
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.map((options, index) => {
                                if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'name_value') {
                                    var hasValue = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_value[index];
                                } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'name-only') {
                                    hasValue = options;
                                } else {
                                    hasValue = options;
                                }
    
                                hasValue = hasValue.replaceAll("'", "");
                                content_value.push(hasValue);
    
                                var sanitized_options = "";
                                var sanitized_value = "";
                                /* eslint-disable */
                                sanitized_options = options.replace(/\</g,"&lt;");   //for <
                                sanitized_options = sanitized_options.replace(/\>/g,"&gt;");   //for >
                                sanitized_value = hasValue.replace(/\</g,"&lt;");   //for <
                                sanitized_value = sanitized_value.replace(/\>/g,"&gt;");
    
                                if (this.selectedValue.includes(sanitized_value)) { //if this is true then this checkbox will be checked
                                    str = str + "<div class='ml-2'><input type='checkbox' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' name='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +"' value='"+sanitized_value+"' checked>"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                } else {
                                    str = str + "<div class='ml-2'><input type='checkbox' id='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"' name='"+
                                        this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +"' value='"+sanitized_value+"' >"+
                                    "<label for='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                    +index+"'>"+sanitized_options+"</label></div>";
                                }
                            });
    
                        } else {
                            str = "<small><i>No data found.</i></small>";
                        }
                    } ///OPTION TYPE CLOSE
    
                    if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.allow_other_option === "yes") {
                        if(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['option-type'] === 'url') {
                            if (!this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.includes('badgepack')) {
                                str = this.allow_other_option_helper(content_value, str, tileOptionsIndex, "checkbox");
                            } 
                        } else {
                            str = this.allow_other_option_helper(content_value, str, tileOptionsIndex, "checkbox");
                        }
                    }
    
                    var prefix_str = "<br><span class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                    sanitized_title+"</span>"+sanitized_details+"<br><br>";
    
    
                    str = prefix_str + "<div class='radio-toolbar'><div class='parent'>"+str+"</div></div>";
    
                    return str;
    },

    urlget_rocketchat_helper(index) {
                    var cont = false;
    
                    if (this.$store.getters.active_tile.tile_options[index].is_condition == true) {
                        if (this.if_function(this.$store.getters.active_tile.tile_options[index].if_json.tile_option_tag_name,
                            this.$store.getters.active_tile.tile_options[index].if_json.condition_value.replace("'", ''), 
                            this.$store.getters.active_tile.tile_options[index].if_json.condition)) {
                            cont = true;                    
                        }
                    } else {
                        cont = true;
                    }
    
                    if (cont == true) {
                        var today = new Date();
                        var currenttileoption = index+1;
        
                        this.main_data = {};
                        this.main_data["data"] = [];
                        this.$store.getters.active_tile.tile_options.map((tiles) => {
                                this.main_data["tile_id"] =  this.$store.getters.active_tile.id;
    
                                var value = this.dynamic_mergecodes[tiles.json.tag_name];
    
                                this.main_data["data"].push({
                                    "sort": tiles.sort,
                                    "tag": tiles.json.tag,
                                    "type": tiles.syntax,
                                    "value": value
                                });
                        });
        
        
                        var formURLGET = {
                            "current_tile_option": currenttileoption,
                            "submit_data": JSON.stringify(this.main_data),
                            "token_id": this.$store.getters.auth_token,
                            "location": this.ip_location,
                            "user_name": this.$store.getters.auth_username,
                            "user_domain": window.location.origin,
                            "user_guid": this.$store.getters.auth_guid,
                            "user_book": this.$store.getters.selected_book,
                            "user_page": this.$store.getters.selected_page,
                            "user_tile": this.$store.getters.active_tile.title,
                            "date_now": today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate(),
                            "time_now": this.getClockTime(),
                            "tap_version": this.appVersion,
                        }
    
                        if (this.file_uploads.length > 0) {
                            var formData = new FormData();
        
                            // Append properties from formSubmit2 to the FormData object
                            for (const key in formURLGET) {
                            if (formURLGET.hasOwnProperty(key)) {
                                formData.append(key, formURLGET[key]);
                            }
                            }
        
                            // Add file data from file_uploads
                            this.file_uploads.forEach(upload => {
                                if (upload.value) {
                                formData.append(`data_${upload.sort}`, upload.value);
                                }
                            });
                        } else {
                            formData = formURLGET;
                        }
        
                        var urlget_settings = {
                            "url": this.baseAPIURL+"/apiv3/autosend.json",
                            "method": "POST",
                            "timeout": 0,
                            "headers": {
                                "auth": this.$store.getters.auth_token,
                            },
                            "processData": false,
                            "mimeType": "multipart/form-data",
                            "contentType": false,
                            "data": formData
                        };
                    
                        axios(urlget_settings)
                        .then((response) => {
                            return response;
                        })
                        .catch((error) => {
                        console.log(error);
                        return error;
                        });
                    }
    },
    
    run_mergecode_search(value) {
                     //THIS BLOCK WILL DETERMINE IF VALIDATION HAS MERGECODES
                    var regex = new RegExp(/\{\{(.*?)\}\}/g);
    
                    value = String(value);
    
                    var matches = value.match(regex);
                    var found;
                    if (matches) {
                        for(var i = 0; i < matches.length; i++) {
                            var reg = new RegExp(/\{\{(.*?)\}\}/g);
                            found = reg.exec(matches[i]);
    
                            value = this.dynamic_mergecodes[found[1]];
                        }
                    }
    
                    return value;
                 //THIS BLOCK WILL DETERMINE IF VALIDATION HAS MERGECODES
    },
    
    allow_other_option_helper(content_value, str, tileOptionsIndex, type) {
                    this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']].forEach(item => {
                        if (!content_value.includes(item)) {
                            var custom_index = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.length;
    
    
                            if (type == 'button') {
                                str = str + "<div class='ml-2'><input type='radio' data-inputtype='otherBtn' id='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +custom_index+"' name='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +"' value='"+item+"' checked style='visibility:hidden;'>"+
                                "<label for='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +custom_index+"'>"+item+"</label></div>";
                            } else {
                                str = str + "<div class='ml-2'><input type='"+type+"' data-inputtype='otherBtn' id='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +custom_index+"' name='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +"' value='"+item+"' checked>"+
                                "<label for='"+
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                                +custom_index+"'>"+item+"</label></div>";
                            }
                            this.other_options[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']] = 1;
                        } else {
                            this.other_options[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']] = "";
                        }
                    });
    
    
                    if (!this.other_options[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']]) {
                        var custom_index = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.option_label.length;
    
    
                        if (type == 'button') {
    
                            str = str + "<div class='ml-2'><input type='radio' data-inputtype='otherBtn' id='"+
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                            +custom_index+"' name='"+
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                            +"' value='Other' style='visibility:hidden;'>"+
                            "<label for='"+
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                            +custom_index+"'>Other</label></div>";
                        } else {
                            str = str + "<div class='ml-2'><input type='"+type+"' data-inputtype='otherBtn' id='"+
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                            +custom_index+"' name='"+
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                            +"' value='Other' >"+
                            "<label for='"+
                            this.$store.getters.active_tile.tile_options[tileOptionsIndex].json['tag_name']
                            +custom_index+"'>Other</label></div>";
                        }
                        
                    }
    
                    return str;
    },

    if_function(a, b, condition) {
        var item = this.dynamic_mergecodes[a];
        if (item == null || item == "") {
            return false
        } else {
            if (condition == 'contains') {
                if (item.includes(b)) {
                    return true;
                } else {
                    for (let i = 0; i < item.length; i++) {
                        if (item[i].includes(b)) {
                            return true;
                        }
                    }
                    return false;
                }
            } else if (condition == 'not' || condition == 'notequal') {
                if (item != b) {
                    return true;
                } else {
                    return false;
                }
            } else if (condition == 'notnull') {
                if ( typeof item === 'object') {
                    if (Object.keys(item).length === 0) {
                        return false
                    } else {
                        return true;
                    }
                } else if (item != null) {
                    if (item.trim().length === 0) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            } else if (condition == 'match') {
                if (item == b) {
                    return true;
                } else {
                    return false;
                }
            } else if (condition == 'less') {
                if (+item < +b) {
                    return true;
                } else {
                    return false;
                }
            } else if (condition == 'greater') {
                if (+item > +b) {
                    return true;
                } else {
                    return false;
                }
            } else if (condition == 'lessequal') {
                if (+item <= +b) {
                    return true;
                } else {
                    return false;
                }
            } else if (condition == 'greaterequal') {
                if (+item >= +b) {
                    return true;
                } else {
                    return false;
                }
            } else if (condition == 'equal') {
                if (item == b) {
                    return true;
                } else {
                    return false;
                }
            } else if (condition == 'badgepack') {
                console.log("BADGEPACK");
            } else if (condition == 'datetime') {
                return true;
            } 
            else if (condition == 'regex' || condition == 'regex2') {
                if (item.match(b)) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        
    },

    progressive_onChange(event) {
        if (event.target.getAttribute("data-inputtype") == "button_bp") {
            this.dynamic_mergecodes[event.target.name] = [];
            this.dynamic_mergecodes[event.target.name].push(event.target.value);


            var index = this.bp_integration.map(badge => {
                return badge.title; 
            }).indexOf(event.target.value);

                if (
                    this.bp_integration[index].type == 'Badge Prerequisite' 
                    && this.bp_integration[index].is_checked == 'no'
                ) {
                    this.$moshaToast("Get "+this.bp_integration[index].title+" badge first to complete the checklist. Contact the badge issuer on how to accomplish this task.", { type: "info" });
                } else if (
                    this.bp_integration[index].type == 'Badge Prerequisite' 
                    && this.bp_integration[index].is_checked == 'yes'
                ) {
                    this.$moshaToast("You've already done this task.", { type: "info" });
                }

                if (
                    this.bp_integration[index].type == 'Manual' 
                    && this.bp_integration[index].allow_user == true  
                    && this.bp_integration[index].is_checked == "no"
                ) {
                    var url = this.bp_integration[index].integration_link;
                    var reg = new RegExp(/\{\{(.*?)\}\}/g);
                    var matches = url.match(reg);
                    var found;

                    if (matches) {
                        for(var i = 0; i < matches.length; i++) {
                            reg = new RegExp(/\{\{(.*?)\}\}/g);
                            found = reg.exec(matches[i]);

                            var startIndexOf = url.indexOf(found[0]);
                            var endIndexOf = startIndexOf+found[0].length;

                            //now find in DYNAMIC MERGECODES IF EXIST
                            url = url.slice(0, startIndexOf) + this.$store.getters.auth_user +  url.slice(endIndexOf);

                        }
                    }

                    axios({
                        method: "put",
                        url: url,
                        headers: { Authorization: "Bearer "+this.badgepack_token }
                    })
                    .then(response => {
                        //handle success
                        this.$moshaToast("Task done!", { type: "success" });
                        this.tile_selected(this.$store.getters.selected_book, this.$store.getters.active_tile.id);
                    })

                } else if (
                    this.bp_integration[index].type == 'Manual' 
                    && this.bp_integration[index].allow_user == false 
                    && this.bp_integration[index].is_checked == "no"
                ) {
                    this.$moshaToast("This task is a manual process. Contact the badge issuer on how to accomplish this task.", { type: "info" });
                } else if (
                    this.bp_integration[index].type == 'Manual' 
                    && this.bp_integration[index].allow_user == false
                    && this.bp_integration[index].is_checked == "yes"
                ) {
                    this.$moshaToast("You've already done this task.", { type: "info" });
                } else if (
                    this.bp_integration[index].type == 'Manual' 
                    && this.bp_integration[index].allow_user == true 
                    && this.bp_integration[index].is_checked == "yes"
                ) {
                    this.$moshaToast("You've already done this task.", { type: "info" });
                }

                if (
                    (this.bp_integration[index].type == 'Ubertickets'
                    || this.bp_integration[index].type == 'PlayerOne') 
                    && this.bp_integration[index].is_checked == 'no'
                ) {
                    window.open(this.bp_integration[index].integration_link,'_blank');
                } else if (
                    (this.bp_integration[index].type == 'Ubertickets'
                    || this.bp_integration[index].type == 'PlayerOne') 
                    && this.bp_integration[index].is_checked == 'yes'
                ) {
                    this.$moshaToast("You've already done this task.", { type: "info" });
                }
        }

        if (event.target.getAttribute("data-inputtype") == "otherBtn") {
            this.progressive_other_input(event.target.name);
        } 

        if (event.target.type == 'file'){
            this.handle_fileuploads(event);
        }


    },

    onChange(event) {
        if (
            event.target.type == 'text' || 
            event.target.type == 'date' || 
            event.target.type == 'time' || 
            event.target.type == 'datetime-local'
        ) {

            if (event.target.type == 'text') {
                var tag = event.target.getAttribute("data-tag");
                var data_tag_index = this.obj.html.indexOf("data-tag='"+tag+"'");
                var data_tag_end_index = data_tag_index+tag.length+11;
                var value_start_index = data_tag_end_index+1;

                var first_close = this.obj.html.indexOf("'", value_start_index);
                var second_close = this.obj.html.indexOf("'", first_close);

                var sanitized_event_value;
                sanitized_event_value = event.target.value.replace(/\</g,"&lt;");   //for <
                sanitized_event_value = sanitized_event_value.replace(/\>/g,"&gt;");  //for >

                this.dynamic_mergecodes[event.target.name] = sanitized_event_value;
                this.obj.html = this.obj.html.slice(0, first_close+1) + sanitized_event_value + this.obj.html.slice(second_close);
            } else if (
                event.target.type == 'date' || 
                event.target.type == 'time' || 
                event.target.type == 'datetime-local'
            ) { 

                var tag = event.target.getAttribute("data-tag");
                var data_tag_index = this.obj.html.indexOf("data-tag='"+tag+"'");
                var data_tag_end_index = data_tag_index+tag.length+11;
                var value_start_index = data_tag_end_index+1;

                var first_close = this.obj.html.indexOf("'", value_start_index);
                var second_close = this.obj.html.indexOf("'", first_close);

                if (event.target.type == 'date') {
                    var mydate = new Date(event.target.value);

                    var dd = String(mydate.getDate()).padStart(2, '0');
                    var mm = mydate.toLocaleString('en-US', {month: 'short'});
                    var yyyy = mydate.getFullYear();

                    var beauty_date = dd + '-' + mm + '-' + yyyy;
                    this.dynamic_mergecodes[event.target.name] = beauty_date;
                } else if (event.target.type == 'time') {
                    this.dynamic_mergecodes[event.target.name] = event.target.value;
                } else if (event.target.type == 'datetime-local') { 
                    var mydate = new Date(event.target.value);

                    var dd = String(mydate.getDate()).padStart(2, '0');
                    var mm = mydate.toLocaleString('en-US', {month: 'short'});
                    var yyyy = mydate.getFullYear();


                    var hh = String(mydate.getHours()).padStart(2, '0');
                    var min = String(mydate.getMinutes()).padStart(2, '0');
                    

                    var beauty_date = dd + '-' + mm + '-' + yyyy + ' ' + hh + ":" + min;

                    this.dynamic_mergecodes[event.target.name] = beauty_date;
                }
                this.obj.html = this.obj.html.slice(0, first_close+1) + event.target.value + this.obj.html.slice(second_close);
            }

            
        } else if (event.target.type == 'file'){
            this.handle_fileuploads(event);
        } else {            
            if (event.target.type == 'checkbox') {
                if (event.target.getAttribute("data-inputtype") == "otherBtn") {
                    this.other_input(event.target.name, event.target.type);
                } else {
                        if (!this.dynamic_mergecodes[event.target.name].includes(event.target.value)) {
                                this.dynamic_mergecodes[event.target.name].push(event.target.value);
                        } else {
                            var index = this.dynamic_mergecodes[event.target.name].indexOf(event.target.value);
                            this.dynamic_mergecodes[event.target.name].splice(index, 1);
                        }
                        if (this.dynamic_mergecodes[event.target.name].includes(event.target.value)) {
                                var self = this;
                                $("input[id^='"+event.target.name+"']").each(function () {
                                    
                                        var remove_target_id = $(this).attr("id");
                                        var remove_event_target_length_chkbx = remove_target_id.length;
        
                                        var index_label_remove_chkbx = self.obj.html.indexOf(remove_target_id+'-labelclass');
                                        
                                        var start_target_length_chkbx = remove_event_target_length_chkbx+index_label_remove_chkbx+12;
                                        var end_target_length_chkbx = start_target_length_chkbx+15;
        
                                        var checker = self.obj.html.substring(start_target_length_chkbx, end_target_length_chkbx);
        
                                        if (checker === "option-checked ") {
                                            self.obj.html = self.obj.html.slice(0, start_target_length_chkbx) + self.obj.html.slice(end_target_length_chkbx);    
                                        }
                                        //--------------------FOR PUTTING CHECKED -----//
                                        var index_id = self.obj.html.indexOf("id='"+remove_target_id+"'");
                                        var start_index = index_id+remove_target_id.length+5;
                                        var end_index = start_index+8;
        
                                        var checked_checker = self.obj.html.substring(start_index, end_index);
        
                                        if (checked_checker === "checked ") {
                                            self.obj.html = self.obj.html.slice(0, start_index) + self.obj.html.slice(end_index);   
                                        }
                                });
                            Object.values(this.dynamic_mergecodes[event.target.name]).map((items) =>{
                                if (items != '') {
                                    var target_id = $("input[id^='"+event.target.name+"'][value='"+items+"']").attr('id');
            
                                    var index_label_chkbx = this.obj.html.indexOf('labelclass-'+target_id+'-labelclass');
                                    var event_target_length_chkbx = target_id.length;
                                    var index_to_append_chkbx = index_label_chkbx+event_target_length_chkbx+23;
                
                                    this.obj.html = this.obj.html.slice(0, index_to_append_chkbx) + "option-checked " + this.obj.html.slice(index_to_append_chkbx);
                
                                    //--------------------FOR PUTTING CHECKED -----//
                                    var index_id = self.obj.html.indexOf("id='"+target_id+"'");
                                    var end_index = index_id+target_id.length+5;
                
                                    this.obj.html = this.obj.html.slice(0, end_index) + "checked " + this.obj.html.slice(end_index);
                                
                                } 
                            });
                        } else {
                            //remove active class
                            
                            var remove_target_id = $("input[id^='"+event.target.name+"'][value='"+event.target.value+"']").attr('id');
                            var remove_event_target_length_chkbx = remove_target_id.length;
            
                            var index_label_remove_chkbx = this.obj.html.indexOf(remove_target_id+'-labelclass option-checked ');
                            var start_target_length_chkbx = remove_event_target_length_chkbx+index_label_remove_chkbx+12;
                            
                            var end_target_length_chkbx = start_target_length_chkbx+15;
                            this.obj.html = this.obj.html.slice(0, start_target_length_chkbx) + this.obj.html.slice(end_target_length_chkbx);   
                            
                            //--------------------FOR PUTTING CHECKED -----//
        
                            var index_id = this.obj.html.indexOf("id='"+remove_target_id+"'");
                            var start_index = index_id+remove_target_id.length+5;
                            var end_index = start_index+8;
        
                            this.obj.html = this.obj.html.slice(0, start_index) + this.obj.html.slice(end_index);   
                        }
                }
            } else {
                if (event.target.getAttribute("data-inputtype") == "button_bp") {
                    this.dynamic_mergecodes[event.target.name] = [];
                    this.dynamic_mergecodes[event.target.name].push(event.target.value);


                    index = this.bp_integration.map(badge => {
                        return badge.title; 
                    }).indexOf(event.target.value);

                        if (
                            this.bp_integration[index].type == 'Badge Prerequisite' 
                            && this.bp_integration[index].is_checked == 'no'
                        ) {
                            this.$moshaToast("Get "+this.bp_integration[index].title+" badge first to complete the checklist. Contact the badge issuer on how to accomplish this task.", { type: "info" });
                        } else if (
                            this.bp_integration[index].type == 'Badge Prerequisite' 
                            && this.bp_integration[index].is_checked == 'yes'
                        ) {
                            this.$moshaToast("You've already done this task.", { type: "info" });
                        }

                        if (
                            this.bp_integration[index].type == 'Manual' 
                            && this.bp_integration[index].allow_user == true  
                            && this.bp_integration[index].is_checked == "no"
                        ) {
                            var url = this.bp_integration[index].integration_link;
                            var reg = new RegExp(/\{\{(.*?)\}\}/g);
                            var matches = url.match(reg);
                            var found;
        
                            if (matches) {
                                for(var i = 0; i < matches.length; i++) {
                                    reg = new RegExp(/\{\{(.*?)\}\}/g);
                                    found = reg.exec(matches[i]);
        
                                    var startIndexOf = url.indexOf(found[0]);
                                    var endIndexOf = startIndexOf+found[0].length;
        
                                     //now find in DYNAMIC MERGECODES IF EXIST
                                    url = url.slice(0, startIndexOf) + this.$store.getters.auth_user +  url.slice(endIndexOf);
        
                                }
                            }

                            axios({
                                method: "put",
                                url: url,
                                headers: { Authorization: "Bearer "+this.badgepack_token }
                            })
                            .then(response => {
                                //handle success
                                this.$moshaToast("Task done!", { type: "success" });
                                this.tile_selected(this.$store.getters.selected_book, this.$store.getters.active_tile.id);
                            })

                        } else if (
                            this.bp_integration[index].type == 'Manual' 
                            && this.bp_integration[index].allow_user == false 
                            && this.bp_integration[index].is_checked == "no"
                        ) {
                            this.$moshaToast("This task is a manual process. Contact the badge issuer on how to accomplish this task.", { type: "info" });
                        } else if (
                            this.bp_integration[index].type == 'Manual' 
                            && this.bp_integration[index].allow_user == false
                            && this.bp_integration[index].is_checked == "yes"
                        ) {
                            this.$moshaToast("You've already done this task.", { type: "info" });
                        } else if (
                            this.bp_integration[index].type == 'Manual' 
                            && this.bp_integration[index].allow_user == true 
                            && this.bp_integration[index].is_checked == "yes"
                        ) {
                            this.$moshaToast("You've already done this task.", { type: "info" });
                        }

                        if (
                            (this.bp_integration[index].type == 'Ubertickets'
                            || this.bp_integration[index].type == 'PlayerOne') 
                            && this.bp_integration[index].is_checked == 'no'
                        ) {
                            window.open(this.bp_integration[index].integration_link,'_blank');
                        } else if (
                            (this.bp_integration[index].type == 'Ubertickets'
                            || this.bp_integration[index].type == 'PlayerOne') 
                            && this.bp_integration[index].is_checked == 'yes'
                        ) {
                            this.$moshaToast("You've already done this task.", { type: "info" });
                        }

                } else if (
                        (event.target.getAttribute("data-inputtype") == "button") 
                        || event.target.getAttribute("data-inputtype") == "name-only"
                ) {
                    
                    this.dynamic_mergecodes[event.target.name] = [];
                    this.dynamic_mergecodes[event.target.name].push(event.target.value);

                    var htmlElement = document.getElementsByTagName("urlmsgbox_"+event.target.name)[0];

                    

                    if (htmlElement) { 
                            var settings = {
                                "url": this.dynamic_mergecodes[event.target.name],
                                "mode": 'cors',
                                "method": "GET",
                                "timeout": 0,
                            };

                            axios(settings)
                            .then((response) => { 
                                index_id = this.obj.html.indexOf("<urlmsgbox_"+event.target.name+">");
                                var udscore = index_id+10;
                                var length_of_tag = event.target.name.length;
                                var closing_urlmsgbox = udscore+length_of_tag+1; //add +1 for the '>' closing tag
                                var index_id_2 = this.obj.html.indexOf("</urlmsgbox_"+event.target.name+">");
                                var startinsert = closing_urlmsgbox+1;
                                var endinsert = index_id_2;

                                if (response.data[0].ListMemo == null) {

                                    var sanitized_result = response.data.replace(/\n/g, "<br />");
                                    this.obj.html = this.obj.html.slice(0, startinsert) + sanitized_result + this.obj.html.slice(endinsert); 

                                } else {

                                    var sanitized_result = response.data[0].ListMemo.replace(/\n/g, "<br />");
                                    this.obj.html = this.obj.html.slice(0, startinsert) + sanitized_result + this.obj.html.slice(endinsert);

                                }
                            })
                            .catch((error) => {
                                return error;
                            });
                    } 

                } else {
                    if (event.target.getAttribute("data-inputtype") == "otherBtn") {
                        this.dynamic_mergecodes[event.target.name] = "Other";
                        this.other_input(event.target.name, event.target.type);
                    } else {
                        this.dynamic_mergecodes[event.target.name] = [];
                        this.dynamic_mergecodes[event.target.name].push(event.target.value);
                    }
                }

                if (this.dynamic_mergecodes[event.target.name].includes(event.target.value)) {
                    //--------------------FOR PUTTING CHECKED -----//
                    self = this;
                    $("input[id^='"+event.target.name+"']").each(function () {

                        var remove_target_id = $(this).attr("id");
                        index_id = self.obj.html.indexOf("id='"+remove_target_id+"'");
                        start_index = index_id+remove_target_id.length+5;
                        end_index = start_index+8;

                        var checked_checker = self.obj.html.substring(start_index, end_index);

                        if (checked_checker === "checked ") {
                            self.obj.html = self.obj.html.slice(0, start_index) +''+ self.obj.html.slice(end_index);   
                        }

                        //remove active class
                        var index_label_remove = self.obj.html.indexOf(remove_target_id+'-radioclass option-checked');
                        var start_target_length = index_label_remove+remove_target_id.length+12;
                        var end_target_length = start_target_length+15;
    
                        if (index_label_remove != '-1') {
                            self.obj.html = self.obj.html.slice(0, start_target_length) + self.obj.html.slice(end_target_length);
                        }
                    })
                    //put active class
                    var index_label = this.obj.html.indexOf('radioclass-'+event.target.id+'-radioclass');
                    var event_target_length = event.target.id.length;
                    var index_to_append = index_label+event_target_length+23;

                    this.obj.html = this.obj.html.slice(0, index_to_append) + "option-checked " + this.obj.html.slice(index_to_append);

                    index_id = this.obj.html.indexOf("id='"+event.target.id+"'");
                    end_index = index_id+event.target.id.length+5;
                    this.obj.html = this.obj.html.slice(0, end_index) + "checked " + this.obj.html.slice(end_index);
                }
            }
        }

        this.$store.getters.active_tile.tile_options.map((tiles) =>{
            
        //OPEN OPTION
            if (tiles.if_json) {
                if (this.if_function(tiles.if_json.tile_option_tag_name, tiles.if_json.condition_value.replace("'", ''), tiles.if_json.condition)) {
                    
                    if (
                        this.if_condition[tiles.json.tag_name] == null 
                        || this.if_condition[tiles.json.tag_name] != true
                    ) {
                        
                        index_id = this.obj.html.indexOf("id='ifCond"+tiles.json.tag_name+"'");
                        first_close = this.obj.html.indexOf("if", index_id);
                        second_close = this.obj.html.indexOf("'", first_close);
                        var get_closing_tag = this.obj.html.indexOf(">", second_close);

                        this.obj.html = this.obj.html.slice(0, second_close+1) + this.obj.html.slice(get_closing_tag);

                        this.if_condition[tiles.json.tag_name] = true;
                    }

                } else {
                        index_id = this.obj.html.indexOf("id='ifCond"+tiles.json.tag_name+"'");

                        first_close = this.obj.html.indexOf("if", index_id);
                        second_close = this.obj.html.indexOf("'", first_close);
                        get_closing_tag = this.obj.html.indexOf(">", second_close);

                        this.obj.html = this.obj.html.slice(0, second_close+1) +" class='hidden'"+this.obj.html.slice(get_closing_tag);

                        this.if_condition[tiles.json.tag_name] = false;
                }
            }

            if (
                ((tiles.syntax === "inputbox" && tiles.json.validation != 'no_validation') && 
                (tiles.syntax === "inputbox" && tiles.json.validation != "")) || 
                (tiles.syntax === "selectbox") ||
                (tiles.syntax === "inputbox" && tiles.json.input_type === 'date') ||
                (tiles.syntax === "inputbox" && tiles.json.input_type === 'time') ||
                (tiles.syntax === "inputbox" && tiles.json.input_type === 'datetime') 
            ) {
                //test validation


                if (this.if_condition[tiles.json.tag_name] == false) {
                    this.validation[tiles.json.tag_name].condition_met = true;

                    this.dynamic_mergecodes[tiles.json.tag_name] = [];

                    $("input[id^='"+tiles.json.tag_name+"']").each(function () {
                                    
                        var remove_target_id = $(this).attr("id");
                        var remove_event_target_length_chkbx = remove_target_id.length;

                        var index_label_remove_chkbx = self.obj.html.indexOf(remove_target_id+'-labelclass');
                        
                        var start_target_length_chkbx = remove_event_target_length_chkbx+index_label_remove_chkbx+12;
                        var end_target_length_chkbx = start_target_length_chkbx+15;

                        var checker = self.obj.html.substring(start_target_length_chkbx, end_target_length_chkbx);

                        if (checker === "option-checked ") {
                            self.obj.html = self.obj.html.slice(0, start_target_length_chkbx) + self.obj.html.slice(end_target_length_chkbx);    
                        }
                        //--------------------FOR PUTTING CHECKED -----//
                        var index_id = self.obj.html.indexOf("id='"+remove_target_id+"'");
                        var start_index = index_id+remove_target_id.length+5;
                        var end_index = start_index+8;

                        var checked_checker = self.obj.html.substring(start_index, end_index);

                        if (checked_checker === "checked ") {
                            self.obj.html = self.obj.html.slice(0, start_index) + self.obj.html.slice(end_index);   
                        }
                    });


                } else {
                    if (this.validation[tiles.json.tag_name]) {
                        var valid_value = this.validation[tiles.json.tag_name].validation_value;
                        if (this.if_function(
                            tiles.json.tag_name,
                            valid_value, 
                            this.validation[tiles.json.tag_name].condition)
                        ) {
                            this.validation[tiles.json.tag_name].condition_met = true;
                        } else {
                            this.validation[tiles.json.tag_name].condition_met = false;
                        }
                    }
                }
            }

            if (tiles.syntax === "open") {
                url = tiles.json.url;
                var reg = new RegExp(/\{\{(.*?)\}\}/g);
                var matches = tiles.json.url.match(reg);
                var found;
                var url;

                if (matches) {
                        found = reg.exec(tiles.json.url);
                        if (this.dynamic_mergecodes[found[1]]) {
                            url = url.slice(0, found['index']) + this.dynamic_mergecodes[found[1]];
                            this.dynamic_mergecodes[tiles.json.tag_name] = url;
                        }
                }

                var open_option = this.obj.html.indexOf("data-option='open'");
                data_tag_end_index = open_option+18;
                value_start_index = data_tag_end_index+1;
    
                first_close = this.obj.html.indexOf("'", value_start_index);
                second_close = this.obj.html.indexOf("'", first_close);


                this.obj.html = this.obj.html.slice(0, first_close+1) + this.dynamic_mergecodes[tiles.json.tag_name] + this.obj.html.slice(second_close);
            }

        //URLGET OPTION
            if (tiles.syntax === 'urlget') {
                url = tiles.json.url;

                reg = new RegExp(/\{\{(.*?)\}\}/g);
                matches = tiles.json.url.match(reg);
                found;


                if (matches) {
                    for(var i = 0; i < matches.length; i++) {
                        reg = new RegExp(/\{\{(.*?)\}\}/g);
                        found = reg.exec(matches[i]);

                        var startIndexOf = url.indexOf(found[0]);
                        var endIndexOf = startIndexOf+found[0].length;

                         //now find in DYNAMIC MERGECODES IF EXIST
                        if (this.dynamic_mergecodes[found[1]]) {
                            url = url.slice(0, startIndexOf) + this.dynamic_mergecodes[found[1]] +  url.slice(endIndexOf);
                            this.dynamic_mergecodes[tiles.json.tag_name] = url;
                        }

                    }
                } else {
                    this.dynamic_mergecodes[tiles.json.tag_name] = url;
                }
            }

            if (tiles.syntax === 'location') {
                url = 'http://maps.google.com/?q=';
                var searchlocation = event.target.value;
                window.open(url+searchlocation,'_blank');
            }
        });
    },

    progressive_other_input(target_name) {
        Swal.fire({
            title: 'Custom Input',
            html: `<input type="text" id="other_value" class="swal2-input" placeholder="Custom Value">`,
            confirmButtonText: 'Continue',
            focusConfirm: false,
            confirmButtonColor: "#145DA0",
            preConfirm: () => {
                const otherValueInput = Swal.getPopup().querySelector('#other_value');
                const otherValue = otherValueInput.value.trim(); // Remove leading and trailing spaces
        
                if (!otherValue) {
                    Swal.showValidationMessage('Custom value cannot be empty or contain only spaces');
                }
        
                return otherValue;
            }
        }).then((result) => {
               /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                var other_value = Swal.getPopup().querySelector('#other_value').value

                
                    var id = $("input[name='"+target_name+"'][data-inputType='otherBtn']").attr('id');
                    $("input[name='"+target_name+"'][data-inputType='otherBtn']").val(other_value);

                    $("label[for='"+id+"']").text(other_value); 
            }
        })
    },

    other_input(target_name, target_type) {
        Swal.fire({
            title: 'Custom Input',
            html: `<input type="text" id="other_value" class="swal2-input" placeholder="Custom Value">`,
            confirmButtonText: 'Continue',
            focusConfirm: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#145DA0"
        }).then((result) => {
               /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                var other_value = Swal.getPopup().querySelector('#other_value').value
                if (target_type == 'checkbox') {
                    if (!this.dynamic_mergecodes[target_name].includes(other_value)) {
                        this.dynamic_mergecodes[target_name].push(other_value);
                    } else {
                        var index = this.dynamic_mergecodes[target_name].indexOf(other_value);
                        this.dynamic_mergecodes[target_name].splice(index, 1);
                    }
                    
                } else {
                    
                    var target_id = $("input[name='"+target_name+"'][data-inputType='otherBtn']").attr('id');
                
                    //--------------------FOR PUTTING CHECKED -----//
                    var index_id = this.obj.html.indexOf("id='"+target_id+"'");
                    var end_index = index_id+target_id.length+5;
                
                    this.obj.html = this.obj.html.slice(0, end_index) + "checked " + this.obj.html.slice(end_index);
                    //--------------------FOR CHANGING the Other Value-----//
                    var index_other = this.obj.html.indexOf("id='otherLabel"+target_name+"'");

                    var first_close = this.obj.html.indexOf(">", index_other);
                    var second_open = this.obj.html.indexOf("<", first_close);
                    
                    if (target_type == 'radio') {
                        this.dynamic_mergecodes[target_name] = other_value;
                        this.obj.html = this.obj.html.slice(0, first_close+1) + '&emsp;'+other_value + this.obj.html.slice(second_open);
                    } else {
                        this.dynamic_mergecodes[target_name] = other_value;
                        this.obj.html = this.obj.html.slice(0, first_close+1) + other_value + this.obj.html.slice(second_open);
                    }

                } 
            }
        })
    },

    getCurrentTile(tileOptionsIndex) {

    
        var today = new Date();
        this.validation = {};

        if (this.$store.getters.active_tile != null) {
            if (this.$store.getters.active_tile.tile_options.length > 0) {
                if (this.$store.getters.active_tile.tile_options) {
                        

                        this.currentStep = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name;

                        var str;

                        if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].syntax === "msgbox") {
                            this.typeOfInput = '';
                            if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.message_type === "markdown") {
                                var str1 = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.message_content.replace("{{user_email}}", this.$store.getters.auth_user)
                                .replace("{{user_username}}", this.user_username)
                                .replace("{{user_domain}}", window.location.origin)
                                .replace("{{tap_version}}", this.appVersion)
                                .replace("{{location}}", this.ip_location)
                                .replace("{{user_book}}", this.$store.getters.selected_book)
                                .replace("{{user_page}}", this.$store.getters.selected_page)
                                .replace("{{user_tile}}", this.$store.getters.active_tile.tile_options[tileOptionsIndex].title)
                                .replace("{{date_now}}", today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate())
                                .replace("{{time_now}}", today.getHours() + ":" + today.getMinutes());
        
                                str1 = str1+"";

                                var sanitized_title = "";
                                /* eslint-disable */
                                sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;")   //for <
                                sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >

                                var fullsizeImage = str1.replace(/alt="" width="320"/g, 'alt="" width="100%"');
                                str = "<h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2>"+md.render(fullsizeImage);


        
                            } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.message_type === "URL") {
                                str = "";
                                var url = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url;
            
                                var reg = new RegExp(/\{\{(.*?)\}\}/g);
                                var matches = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.match(reg);
                                var found;
                                url;
                                if (matches) {
                                    
                                        found = reg.exec(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url);
                                        if (this.dynamic_mergecodes[found[1]]) {
                                            
                                            url = url.slice(0, found['index']) + this.dynamic_mergecodes[found[1]];
                                        }
                                }

                                var sanitized_title = "";
                                var sanitized_msg_url = "";
                                /* eslint-disable */
                                sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;")   //for <
                                sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >

                                var msg_url_value = this.message_url[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name];
                                
                                var arraynonstr = Array.from(this.message_url[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]);
                                var arrayAsString = arraynonstr.join(', ');

                                if (typeof msg_url_value === 'string') {
                                    sanitized_msg_url = this.message_url[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name].replace(/\n/g, "<br />");
                                } else if (typeof msg_url_value === 'object') {
                                    sanitized_msg_url = arrayAsString.replace(/\n/g, "<br />");
                                } else {
                                    sanitized_msg_url = arrayAsString.replace(/\n/g, "<br />");
                                }


                                if (url.includes('uberlist')) {
                                    str = "<h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><p>"+sanitized_msg_url+"</p>";
                                } else {
                                    if (matches) {
                                        str = "<h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><urlmsgbox_"+found[1]+"><iframe src='"+sanitized_msg_url+"' style='width: 100% !important; height: 300px !important;' title='description' ></iframe></urlmsgbox_"+found[1]+">";
                                    } else { 
                                        str = "<h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><iframe src='"+sanitized_msg_url+"' style='width: 100% !important; height: 300px !important;' title='description' ></iframe>";
                                    
                                    }
                                    }
                            } else {

                                var sanitized_title = "";
                                    /* eslint-disable */
                                sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;")   //for <
                                sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                                
                                str = "<h2 class='font-medium leading-tight text-2xl mt-0 mb-2'>"+sanitized_title+"</h2><br>"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.message_content.replace("{{user_email}}", this.$store.getters.auth_user)
                                .replace("{{user_username}}", this.user_username)
                                .replace("{{user_domain}}", window.location.origin)
                                .replace("{{tap_version}}", this.appVersion)
                                .replace("{{location}}", this.ip_location)
                                .replace("{{user_book}}", this.$store.getters.selected_book)
                                .replace("{{user_page}}", this.$store.getters.selected_page)
                                .replace("{{user_tile}}", this.$store.getters.active_tile.tile_options[tileOptionsIndex].title)
                                .replace("{{date_now}}", today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate())
                                .replace("{{time_now}}", today.getHours() + ":" + today.getMinutes());

                                var fullsizeImage = str.replace(/alt="" width="320"/g, 'alt="" width="100%"');
                                str = fullsizeImage;
                            }

                        
                        } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].syntax === "inputbox") {
                            this.typeOfInput = 'inputbox';  
                            
                            if (!this.dynamic_mergecodes.hasOwnProperty(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name)) {
                                this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]: ''});

                                var reg = new RegExp(/\{\{(.*?)\}\}/g);
                                var matches = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.default.match(reg);

                                
                                var found;
                                if (matches) {
                                        for (var i = 0; i < matches.length; i++) {
                                        found = reg.exec(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.default);
                                        this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = this.run_mergecode_search(this.dynamic_mergecodes[found[1]]);    
                                        }
                                } else {
                                    this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.default;            
                                }
                            }
                        

                            var sanitized_title = "";
                            var sanitized_details = "";
                            /* eslint-disable */
                            sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;")   //for <
                            sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                            
                            /* eslint-disable */
                            sanitized_details = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.details.replace(/\</g,"&lt;")   //for <
                            sanitized_details = sanitized_details.replace(/\>/g,"&gt;")   //for >

                            var input_type = 'text';

                            if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == 'text') {
                                input_type = 'text';
                            } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == 'date') { 
                                input_type = 'date';
                            } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == 'time') { 
                                input_type = 'time';
                            } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == 'datetime') { 
                                input_type = 'datetime-local';
                            } 

                            if (
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == 'date' ||
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == 'time' ||
                                this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == 'datetime'
                            ) {
                                this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                    "validation_value":'',
                                    "condition":'datetime',
                                    "message":'This field is required.',
                                    "condition_met":false
                                }

                                var default_value = this.run_mergecode_search(this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]);

                                str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                    sanitized_title+"</label>"
                                    +"<label id='validator_"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                    +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                    sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.placeholder+"' name='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' value='"+default_value+"'>";
                            
                            } else {
                                
                                var default_value = this.run_mergecode_search(this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]);
                            
                                if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation != 'no_validation' && this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation != "") {
                                    this.validation[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = {
                                                                            "validation_value":this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation_value,
                                                                            "condition":this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation,
                                                                            "message":this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation_message,
                                                                            "condition_met":false
                                                                            }
                                    if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation_message == "") {
                                        var valid_message = "This field is required.";
                                    } else {
                                        valid_message = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation_message;
                                    }


                                    str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                    sanitized_title+"</label>"
                                    +"<label id='validator_"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' class='hidden'><small class='text-red-700'>"+valid_message+"</small></label>"
                                    +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                    sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.placeholder+"' name='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' value='"+default_value+"'>";
                                } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation === "" || this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.validation === null) {
                                    str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold mb-2'>"+
                                    sanitized_title+"</label><label>"+
                                    sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.placeholder+"' name='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' value='"+default_value+"'>";
                                } else {
                                    str = "<label class='block uppercase tracking-wide text-gray-700 text-md font-bold mb-2'>"+
                                    sanitized_title+"</label><label>"+
                                    sanitized_details+"</label><input type='"+input_type+"' class='appearance-none block w-1/2 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500' placeholder='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.placeholder+"' name='"+
                                    this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' value='"+default_value+"'>";
                                }
                            }  

                        } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].syntax === "selectbox") {
                            if ((this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == "button" || this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == "name-only")) {
                            str = this.selectbox_button(tileOptionsIndex);
                            } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.input_type == "radio") {
                                str = this.selectbox_radio(tileOptionsIndex);
                            } else {
                                
                                str = this.selectbox_multiple(tileOptionsIndex);
                            }
                            
                        } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].syntax === "open") {
                                str = "";
                                var url = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url;
            
                                var reg = new RegExp(/\{\{(.*?)\}\}/g);
                                var matches = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.match(reg);
                                var found;
                                url;
                                if (matches) {
                                    
                                        found = reg.exec(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url);
                                        if (this.dynamic_mergecodes[found[1]]) {
                                            
                                            url = url.slice(0, found['index']) + this.dynamic_mergecodes[found[1]];
                                            this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = url;
                                        }
                                } else {
                                    this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = url;
                                }
                            
                                str = "<div class='outer-div'><div class='inner-div'><a data-option='open' href='"+this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]
                                +"' target='_blank' class='' style='text-decoration:none;color: #0089cf;'>"
                                +"<center><img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABHNCSVQICAgIfAhkiAAAAjFJREFUWEftmE1SwjAUgF9Y6FKPgCeQegE4AjcQTyBsRFbKCsoGb6A3EE8AXMBwA/AGuNQF8b3Eig6lyUvbzDhDZuh0mPfz9SXvpxUQYg1kFQQ84q/BcLeGDXQEQ8FfdCinTLjE1zoMYCyV79OFApwhYN0HMgygPoNqAUKccCHDABLVSNZgo2ZcyHCAnpB/AUevdVDCXgoEvMBNtOBul5YfyBZUsOQ4LgNI4VdaqeaoB1ijrqAXPTnLb/1M8fbUVU/AWJ7CJyw5Stq4ghXcRmeujr6DwIIj2wJiSVG4dHb0I6jeoHtRddIzO8SGM4BDucSrm6PfNK5bnAWn1Due+TaWoId92U0RTKvy/czICJg4JYkNroIJScmWUYLSAbtR/vLjCpdEIh1yXg4gFy6BpI5TAcoJaotzrBSt4gF94facqWIBC4ZLysxukvicwRLgigMsCa4YwBLh8gOWDJcPMACcP2AgOD9Amn4+QKb2b+qtSftymiLsQvw6GMs2mh3vmC4Bzi+CaYAcOJqoBdzpB1TQtw29/AjqLdYvP+cmijgXCtF0mm4GsoG9lubC7RIQZenyAcm0mcJb2ssRNvdOtLafJpSI5T1eTfS2qw/diP5PXX6ATjQpQgdA38gleocIHiK4G4F/msV5t5Knb62DM7Tn9XGRx7G3Els7SRNVnwtxxjcyxy7SyFIzL+hDiZ8e4JpvP48G9vANflnoRSs7IEmYRk49seTtRjAlJnCMvhx6+Bcecl2AxOvnJgAAAABJRU5ErkJggg==' class='h-[50px] '><small> Click to open in a new tab</small></a></center></div></div>";
                        } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].syntax === "location") {
                            str = "";

                            var sanitized_title = "";
                            /* eslint-disable */
                            sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;")   //for <
                            sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >

                            var reg = new RegExp(/\{\{(.*?)\}\}/g);
                            var matches = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.description.match(reg);


                            var found;
                            if (matches) {
                                    for (var i = 0; i < matches.length; i++) {
                                    found = reg.exec(this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.description);
                                    this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = this.dynamic_mergecodes[found[1]];    
                                    }
                            } else {
                                this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name] = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.description;            
                            }
                        
                            str = "<div>" +
                                "<iframe width='100%' height='380' style='border:0;' loading='lazy' allowfullscreen referrerpolicy='no-referrer-when-downgrade'" +
                                "src='https://www.google.com/maps/embed/v1/place?key=" + this.gmaps + "&q=" +
                                this.dynamic_mergecodes[this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]
                                + "'></iframe></div><center><p class='uppercase tracking-wide text-gray-700 font-bold'>" +
                                sanitized_title + "</p></center>";
                        } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].syntax === "file") {
                            this.typeOfInput = "file";

                            var sanitized_title = "";
                            var sanitized_details = "";
                            /* eslint-disable */
                            sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;")   //for <
                            sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                            
                            
                            /* eslint-disable */
                            sanitized_details = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.description.replace(/\</g,"&lt;")   //for <
                            sanitized_details = sanitized_details.replace(/\>/g,"&gt;")   //for >
                        
                            str = "";
                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]: ''});
                            
                            // Define the tag name you want to check for
                            const tagToCheck = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name;

                            // Check if the tag_name already exists in this.file_uploads
                            const tagExists = this.file_uploads.some(upload => upload.tag_name === tagToCheck);

                            if (!tagExists) {
                                this.file_uploads.push({
                                    sort: this.$store.getters.active_tile.tile_options[tileOptionsIndex].sort,
                                    tag_name: this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name,
                                    value: ''
                                });

                                str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                sanitized_title+"</label>"
                                +"<label id='validator_"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                sanitized_details+"</label>"
                                +"<div>"
                                    +"<div class='drop-zone-idle dropzone' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"'>"
                                        +"<input type='file' id='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' size='60'/>"
                                        +"<center><p style='width: 20%;'>or Drag and Drop a file</p></center>"
                                    +"</div>"
                                +"</div>";
                            } else {

                                // Define the specific tag_name you want to display
                                const specificTagName = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name;

                                // Filter the objects with the specific tag_name
                                const matchingUploads = this.file_uploads.filter(upload => upload.tag_name === specificTagName);

                                // Display the values of the matching uploads
                                matchingUploads.forEach(upload => {
                                    // Display or use the values as needed
                                    this.uploaded_file_name = upload.value.name;
                                });

                                str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                sanitized_title+"</label>"
                                +"<label id='validator_"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                sanitized_details+"</label>"
                                +"<div>"
                                    +"<div class='drop-zone-idle dropzone' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"'>"
                                        +"<center><p style='width: 50%;'>File to be uploaded: <strong>"+this.uploaded_file_name+"</strong></p></center>"
                                        +"<input type='file' id='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' name='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' size='60'/>"
                                        +"<center><p style='width: 20%;'>or Drag and Drop a file</p></center>"
                                    +"</div>"
                                +"</div>";
                            }
                        } else if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].syntax === "video_media") {
                            this.typeOfInput = "video_media";

                            var sanitized_title = "";
                            var sanitized_details = "";
                            /* eslint-disable */
                            sanitized_title = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.title.replace(/\</g,"&lt;")   //for <
                            sanitized_title = sanitized_title.replace(/\>/g,"&gt;")   //for >
                            
                            
                            /* eslint-disable */
                            sanitized_details = this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.description.replace(/\</g,"&lt;")   //for <
                            sanitized_details = sanitized_details.replace(/\>/g,"&gt;")   //for >
                        
                            
                            str = "";
                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { a: 'loaded', [this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name]: ''});
                            
                            if (this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url.startsWith('https://')) {
                                var vidmedia = "<center><video style='height: 480px;' controls controlsList='nodownload'>"
                                +"<source src='"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.url+"'>"
                                +"Your browser does not support the HTML5 video tag. Please update your browser or try a different one."
                                +"</video></center>";  
                            } else {
                                vidmedia = "<center><p style='background-color: black; color: white; width: 60%; height: 100px;'>Failed to load the video because the provided URL is not secure.</p></center>";  
                            }

                            str = "<br><label class='block uppercase tracking-wide text-gray-700 text-md font-bold'>"+
                                    sanitized_title+"</label>"
                                    +"<label id='validator_"+this.$store.getters.active_tile.tile_options[tileOptionsIndex].json.tag_name+"' class='hidden'><small class='text-red-700'>This field is required.</small></label>"
                                    +"<label class='block  tracking-wide text-gray-700 text-md mb-2'>"+
                                    sanitized_details+"</label>"
                                    +"<div>"
                                        +vidmedia
                                    +"</div>";
                        }
                        
                        return str;   
                        
                }
            } else {
                return "Tile does not have any user option.";
            }
        }
    },
};